enum AdminRoutes {
    DASHBOARD = "dashboard",
    ORDERS = "orders",
    ORDER = "order",
    ORDER_GROUPS = "order_groups",
    ORDER_GROUP = "order_group",
    PRODUCTS = "products",
    PRODUCT = "product",
    DAY2DAY = "day2day",
    AGGREGATED_ORDERS = "aggregated_orders",
    PRODUCT_SALES = "product_sales",
    ADMIN_USERS = "admin_users",
    ADMIN_USER = "admin_user",
    EMPLOYEES = "employees",
    EMPLOYEE = "employee",
    JOB_LOCKS = "job_locks",
    SYSTEM_SETTINGS = "system_settings",
    PICKCONTAINERS = "pick_containers",
    PICKCONTAINER = "pick_container",
    PICKORDERS = "pick_orders",
    TABLET = "tablet",
    TABLETS = "tablets",
    CATEGORIES = "categories",
    CATEGORY = "category",
    INGREDIENTS = "ingredients",
    INGREDIENT = "ingredient",
    PACKAGES = "packages",
    PACKAGE = "package",
    EANS = "eans",
    PRODUCTION_PLANS = "production_plans",
    PRODUCTION_PLAN = "production_plan",
    PROTOCOLS = "protocols",
    PROTOCOL = "protocol",
    STOCK_ITEMS = "stock_items",
    PAST_STOCK_QUANTITIES = "past_stock_quantities",
    OPERATIONAL_COSTS = "operational_costs",
    OPERATIONAL_COST = "operational_cost",
    LABELS = "labels",
    EXPEDITION_PACKAGES = "expedition_packages",
    EXPEDITION_LABEL_TYPES = "expedition_label_types",
    EXPEDITION_LABEL_TYPE = "expedition_label_type",
    EXPEDITION_USERS = "expedition_users",
    EXPEDITION_USER = "expedition_user",
    PACKAGE_CODES = "package_codes",
    PACKAGE_CODE = "package_code",
    TEMPERATURE_CONTROL = "temperature_control",
    PROTOTYPES = "prototypes",
    PROTOTYPE = "prototype",
    PREPRODUCTS = "preproducts",
    PREPRODUCT = "preproduct",
    TABLET_MIXES = "tablet_mixes",
    TABLET_MIX = "tablet_mix",
    MIX_STOCKS = "mix_stocks",
    EXPEDITION_USER_ACTIONS = "expedition_user_actions",
    SENT_PACKAGES = "sent_packages",
    MIXING_MIXES = "mixing_mixes",
    MIX_COMPLETION = "mix_completion",
    LOGGING = "logging",
    WAITING_ORDERS = "waiting_orders",
    REWARDS = "rewards",
    ORDERED_MIXES = "ordered_mixes",
    PRODUCTION_ANALYSIS = "production_analysis",
    PICKING_ITEMS = "picking_items",
    ROLES = "roles",
    ROLE = "role",
    ORDERS_MISSING_ITEMS = "orders_missing_items",
    PICKING_SETTINGS = "picking_settings",
    LOGGED_IN_USERS = "logged_in_users",
    ORDERS_IMPORT = "orders_import",
    CART = "cart",
    CARRIER_HANDOVER_DATE = "carrier_handover_date",
    DELIVERY_ESTIMATES = "delivery_estimates",
}

export default AdminRoutes;
